export const projectData = [
    {
        "id": 1,
        "name": "Nature Tours",
        "page": "https://css-sass-project.netlify.com/",
        "description": "SASS project with many different features and effects.",
        "image": "css"
    },
    {
        "id": 2,
        "name": "Rock Paper Scissors",
        "page": "https://stensaxpawse.netlify.com/",
        "description": "Simple rock paper scissor game written with javascript.",
        "image": "sten"
    },
    {
        "id": 3,
        "name": "Budget App",
        "page": "https://budgetjavascript.netlify.com/",
        "description": "A vanilla Javascript budget app where you can organize your income and expenses.",
        "image": "budget"
    },
    {
        "id": 4,
        "name": "Opera Reviews",
        "page": "https://lascala-flexbox.netlify.com/",
        "description": "Opera reviewing app styling written with CSS Flexbox.",
        "image": "opera"
    },
    {
        "id": 5,
        "name": "Realtor Page",
        "page": "https://pergridproject.netlify.com/",
        "description": "Page where you can find your dream house written with CSS Grid",
        "image": "grid"
    },
    {
        "id": 5,
        "name": "Burger Builder",
        "page": "https://burger-react-1190f.web.app/",
        "description": "Burger Restaurant built with React",
        "image": "burger"
    }
]